import React from "react";
import { Button, Modal } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { Link } from "react-router-dom";
import { Trans } from "@payping/utils/localeUtils";
import { DashboardRoutes } from "@/router";
import { useImmerAtom } from "jotai-immer";
import { coreAtom } from "@/core/state/root";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const toStandardAtom = selectAtom(coreAtom, (val) => val.upgradeUserPanel.toStandard);

const DashboardToolsUpgradeUserPlanToStandardModal: React.FC = () => {
  const [toStandard] = useAtom(toStandardAtom);
  const [, setCoreState] = useImmerAtom(coreAtom);

  const { t } = useAppTranslation();

  const services = {
    onlineShop: {
      title: t("dashboardTools.upgradeUserPlanToStandardModal.services.onlineShop"),
    },
  };

  const handleCloseModal = () => {
    setCoreState((draft) => {
      draft.upgradeUserPanel.toStandard.service = "onlineShop";
      draft.upgradeUserPanel.toStandard.showModal = false;
    });
  };

  return (
    <Modal
      open={toStandard.showModal}
      onCancel={handleCloseModal}
      zIndex={9000}
      centered
      closable
      title={t("dashboardTools.upgradeUserPlanToStandardModal.title")}
      footer={
        <Link className="tw-w-full" to={DashboardRoutes.user.upgrade.url} onClick={() => handleCloseModal()}>
          <Button className="tw-w-full" type="primary">
            {t("dashboardTools.upgradeUserPlanToStandardModal.callToAction")}
          </Button>
        </Link>
      }
    >
      <p className="tw-mb-8">
        {!toStandard.service ? (
          ""
        ) : (
          <Trans
            i18nKey={"dashboardTools.upgradeUserPlanToStandardModal.content"}
            components={{ span: <span /> }}
            values={{
              serviceName: services[toStandard.service].title,
            }}
          />
        )}
      </p>
    </Modal>
  );
};

export default DashboardToolsUpgradeUserPlanToStandardModal;
